import React from 'react';
import {
  ExtensionSlot,
} from 'piral-core';

// Helper function to render multiple extension slots for a region
const renderSlots = (regionName, props, maxSlots = 10) => {
  const slots = [];

  // Render base slot (e.g., "east")
  slots.push(<ExtensionSlot key={regionName} name={regionName} params={props} />);

  // Render numbered slots (e.g., "east-1", "east-2", etc.)
  for (let i = 1; i <= maxSlots; i++) {
    slots.push(<ExtensionSlot key={`${regionName}-${i}`} name={`${regionName}-${i}`} params={props} />);
  }

  return slots;
};

/**
 * Border Layout Component
 * 
 * This layout divides the screen into 5 distinct regions using CSS Grid:
 * - top: Header region (full width, auto height)
 * - west: Left sidebar (200px wide)
 * - center: Main content area (flexible, takes remaining space)
 * - east: Right sidebar (250px wide)
 * - bottom: Footer region (full width, auto height)
 * 
 * AVAILABLE EXTENSION SLOTS:
 * - "top", "west", "center", "east", "bottom"
 * 
 * MULTIPLE SLOTS PER REGION:
 * You can register multiple extensions to the same region using numbered suffixes.
 * Extensions will be rendered vertically (stacked) within their region.
 * 
 * Supported slot names for each region:
 * - Base: "east" (or "top", "west", "center", "bottom")
 * - Numbered: "east-1", "east-2", "east-3", ... up to "east-10"
 */
export default {
  Layout: (props) => {
    const { pageKey, ...otherProps } = props;
    const prefix = `${pageKey || ''}-`;
    
    return (
      <div style={{
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        display: 'grid',
        gridTemplateAreas: '"top top top" "west center east" "bottom bottom bottom"',
        gridTemplateRows: 'auto 1fr auto',
        gridTemplateColumns: '200px 1fr 250px',
        height: '100vh',
        width: '100vw',
        overflow: 'hidden'
      }}>
        <div style={{
          gridArea: 'top',
          padding: '10px 20px'
        }}>
          {renderSlots(`${prefix}top`, otherProps)}
        </div>

        <div style={{
          gridArea: 'west',
          padding: '20px',
          overflowY: 'auto'
        }}>
          {renderSlots(`${prefix}west`, otherProps)}
        </div>

        <div style={{
          gridArea: 'center',
          padding: '20px',
          overflowY: 'auto'
        }}>
          {renderSlots(`${prefix}center`, otherProps)}
        </div>

        <div style={{
          gridArea: 'east',
          padding: '20px',
          overflowY: 'auto'
        }}>
          {renderSlots(`${prefix}east`, otherProps)}
        </div>

        <div style={{
          gridArea: 'bottom',
          padding: '10px 20px'
        }}>
          {renderSlots(`${prefix}bottom`, otherProps)}
        </div>
      </div>
    );
  },

}